import Purposes from "./Purposes";
export default Purposes;
